import { all, takeLeading } from 'redux-saga/effects';
import { api, commonApiSaga } from 'redux/helpers/api';
import types from './types';


export default function* sharepointSagas() {
  yield all([
    takeLeading(types.getSharepointSettings, commonApiSaga, { apiFn: api.sharepoint.get, workspaceId: true }),
    takeLeading(types.syncSharepointRoot, commonApiSaga, { apiFn: api.sharepoint.syncRoot, workspaceId: true }),
  ]);
}
